import { render, staticRenderFns } from "./liewid.vue?vue&type=template&id=b1648d78&scoped=true"
import script from "./liewid.vue?vue&type=script&lang=js"
export * from "./liewid.vue?vue&type=script&lang=js"
import style0 from "./liewid.vue?vue&type=style&index=0&id=b1648d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1648d78",
  null
  
)

export default component.exports